"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackQuestion = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _definitions = require("../questionTypes/definitions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FeedbackQuestion = props => {
  const {
    question,
    response,
    onChange
  } = props;

  const handleChange = patch => {
    onChange(_objectSpread(_objectSpread({}, response), patch));
  };

  const QuestionTypeComponent = _definitions.questionTypeToComponentMapping[question.type];
  return /*#__PURE__*/React.createElement("div", {
    className: 'ctrf-question-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'ctrf-question-title'
  }, question.title), /*#__PURE__*/React.createElement(QuestionTypeComponent, {
    disabled: props.disabled,
    language: props.language,
    question: question,
    value: response === null || response === void 0 ? void 0 : response.value,
    onChange: value => handleChange({
      value
    })
  }), question.includeFreeFormField ? /*#__PURE__*/React.createElement("div", {
    className: "ctrf-question-free-form"
  }, /*#__PURE__*/React.createElement(_reactComponents.TextField, {
    disabled: props.disabled,
    value: response === null || response === void 0 ? void 0 : response.text,
    label: question.freeFormFieldTitle,
    onChange: e => handleChange({
      text: e.target.value
    })
  })) : null);
};

exports.FeedbackQuestion = FeedbackQuestion;
FeedbackQuestion.defaultProps = {
  language: 'en'
};